import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import { Panel } from "EventLight/Common/FieldLayout";
import { Div } from "components/Base";
import MessageList from "./MessageList";

const decorate = connect(
  state => ({
    activity: getters.activity(state)
  }),
  {
    updateField: actions.updateField
  }
);
const Content = ({ activity }) => (
  <Div
    bg="neutral0"
    style={{ overflowY: "auto", padding: "25px", height: 650 }}
  >
    <Panel>
      {!R.isEmpty(activity) &&
        activity.map(activity => <MessageList {...activity} />)}
    </Panel>
  </Div>
);

export default decorate(Content);
